import {useIsomorphicLayoutEffect} from '@sail/engine';

type Config = {
  node: HTMLElement | null;
  root?: HTMLElement | null;
  threshold: number;
  handler: (entry: IntersectionObserverEntry) => void;
  disabled: boolean;
};

export function useIntersectionObserver({
  node,
  root,
  threshold,
  handler,
  disabled,
}: Config): void {
  useIsomorphicLayoutEffect(() => {
    if (node && !disabled) {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          handler(entry);
        },
        {root, threshold},
      );

      observer.observe(node);
      return () => observer.disconnect();
    }
  }, [node, root, disabled, threshold, handler]);
}
